exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#privacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#privacy h1 {\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div {\n  text-indent: 0.31rem;\n  margin: 0.1rem 0;\n}\n#privacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#privacy div.sub-p {\n  text-indent: 0.59rem;\n}\n#privacy div a {\n  color: #000;\n}\n#privacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-18d0c175","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/module/privacy/privacy.vue
// module id = 351
// module chunks = 14